// @flow
import styled from 'styled-components';

export const CheckboxInput = styled.input.attrs(({ type = 'checkbox' }) => ({
  type,
}))``;
